import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import Image from '../../Images/Image'
import LabelList from '../../Labels/LabelList'
import Avatar from '../../Avatar'
import StatSmall from '../../Infographics/StatSmall'

const cardImage = css`
  mix-blend-mode: multiply;
`

const headingWrap = css`
  .heading--hover {
    background-image: linear-gradient(180deg, transparent 70%, #8bd0ff 0);
    background-size: 0 100%;
  }
  &:hover {
    .heading--hover {
      background-size: 100% 100%;
    }
  }
`

const imageLink = css`
  &:hover {
    .${cardImage} {
      filter: grayscale(100%);
    }
  }
`

const CardHorizontal = ({
  author,
  heading,
  image,
  logo,
  labels,
  link,
  stat,
  subheading,
}) => {
  return (
    <article className="md:grid md:grid-cols-3 md:gap-10">
      <div>
        <a
          className={`${imageLink} md:col-span-1 group relative block overflow-hidden bg-blue-transparent hover:bg-blue-200 focus:bg-blue-200 transition-colors ease-linear duration-500`}
          href={link.url}
          target={link.target ? link.target : null}
        >
          {logo && (
            <div className="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full bg-gray-700 bg-opacity-60 transition-image ease-linear duration-500">
              <Image className="h-10 lg:h-16 w-auto" {...logo}></Image>
            </div>
          )}
          <Image
            className={`${cardImage} z-0 block w-full h-auto transition-image ease-linear duration-500`}
            {...image}
          />
        </a>
      </div>
      <div className="md:col-span-2">
        {labels && (
          <div className="mt-4 md:mt-0">
            <LabelList labels={labels} />
          </div>
        )}
        <div className={`${headingWrap} group cursor-pointer`}>
          {heading && (
            <h3 className="mt-3 text-2xl md:text-3xl lg:text-4xl leading-tight font-serif font-bold text-gray-700">
              <a href={link.url} target={link.target ? link.target : null}>
                <span class="heading--hover bg-no-repeat transition-bg-size ease-in-out duration-500">
                  {heading}
                </span>
              </a>
            </h3>
          )}
          {subheading && (
            <a href={link.url} target={link.target ? link.target : null}>
              <p
                className="mt-3 text-base lg:text-lg leading-normal font-sans font-normal text-gray-600"
                dangerouslySetInnerHTML={{ __html: subheading }}
              ></p>
            </a>
          )}
        </div>
        {author && (
          <div className="mt-6">
            <Avatar {...author} isSmall></Avatar>
          </div>
        )}
        {stat && (
          <div class="mt-4 pt-4 border-t border-gray-400">
            <StatSmall {...stat}></StatSmall>
          </div>
        )}
      </div>
    </article>
  )
}

CardHorizontal.propTypes = {
  author: t.object,
  heading: t.string,
  image: t.object,
  logo: t.object,
  labels: t.object,
  link: t.object,
  stat: t.object,
  subheading: t.string,
}

CardHorizontal.defaultProps = {}

export default CardHorizontal
